<template>
  <layout
    title="Z Money"
    >
    
   Z Money

    <w-divider class="my2" />

    <w-form>
    <z-money :validators="[validators.required]" v-model:originalValue="uangku" label="Z Money"></z-money>
    UANGKU : {{uangku}}
    </w-form>
    
  </layout>
</template>

<script>
import ZResource from '@/Modules/z-resource'
export default {
  extends: ZResource,
  data() {
    return {uangku:100000}
  }
}
</script>
